import { CTAProps } from '@ldp-web/component-library/ui/molecules/breadcrumbs';

export const STORE_TYPES = {
  SSP: 'SSP', // Shoppers Simply Pharmacy
  SDM: 'SDM', // Shoppers Drug Mart
  PHX: 'PHX', // Pharmaprix
  STTP_PSS: 'STTP-PSS', // Pharmaprix Simplement Santé
  SCC: 'SCC', // Specialty Care Centre
  WW: 'WW', // Wellwise
};

export const enum TAB_STORE_DETAILS {
  STORE = 0,
  PHARM_AND_SERVICES = 1,
  PHARM_CARE_CLINIC = 2,
}

const BASE_ICON_URL =
  'https://dis-prod.assetful.loblaw.ca/content/dam/loblaw-companies-limited/creative-assets/sdmi/2025/ad-hoc/mb-15512-store-details-page';

export const STORE_DETAILS_TAB_ICONS = {
  STORE_BLACK_URL: `${BASE_ICON_URL}/Store%20black.png`,
  STORE_RED_URL: `${BASE_ICON_URL}/Store%20red.png`,
  PHARMACY_BLACK_URL: `${BASE_ICON_URL}/Pharmacy%20services%20black.png`,
  PHARMACY_RED_URL: `${BASE_ICON_URL}/Pharmacy%20red.png`,
  CLINIC_BLACK_URL: `${BASE_ICON_URL}/Clinic%20black.png`,
  CLINIC_RED_URL: `${BASE_ICON_URL}/Clinic%20red.png`,
};

export const PHARMACY_PREFIX_MAP: Record<string, string> = {
  SSP: 'Shoppers Simply Pharmacy',
  SDM: 'Shoppers Drug Mart',
  // Add mappings here coming from API
};

export const STORE_DETAILS_BREADCRUMBS: Record<string, CTAProps[]> = {
  en: [
    {
      text: 'Store locator',
      url: '/store-locator',
    },
    {
      text: 'Store details',
      url: null,
    },
  ],
  fr: [
    {
      text: 'Localisateur de magasins',
      url: '/store-locator',
    },
    {
      text: 'Détails sur le magasin',
      url: null,
    },
  ],
};

export const STORE_TYPES_NAMES = [
  'Pharmaprix Simplement Santé',
  'Specialty Care Centre',
  'Wellwise',
  'Shoppers Drug Mart',
  'Pharmaprix',
  'Specialty Health Network',
  'Shoppers Simply Pharmacy',
];
